// src/services/arguenteService.js
import api from '../services/api';

export const listarArguentes = async () => {
    return api.get('/arguentes');
};

export const obterArguente = async (id) => {
    return api.get(`/arguentes/${id}`);
};

export const criarArguente = async (arguente) => {
    return api.post('/arguentes', arguente);
};

export const atualizarArguente = async (id, arguente) => {
    return api.put(`/arguentes/${id}`, arguente);
};

export const excluirArguente = async (id) => {
    return api.delete(`/arguentes/${id}`);
};
